import { IState } from './model';
import { STATE_KEY } from './state';

export const storeState = (state: Partial<IState>) => {
  sessionStorage.setItem(STATE_KEY, JSON.stringify(state));
};
